import * as React from 'react';
import TailwindModal from './Tailwind/TailwindModal';
import TailwindButton from './Tailwind/TailwindButton';
import apiService from '../services/ApiService';
import { saveAs } from 'file-saver';

export default function ReportsModal({ open, setOpen, model, scenario, sensitivity }) {

    const [loading, setLoading] = React.useState(false);

    const files = [
      { name: 'Assumptions Booklet', routeName:'assumptions_booklet' },
      { name: 'Main Financial Model Terms', routeName:'main_model_terms' },
      { name: 'All Financial Model Terms', routeName:'all_model_terms' },
    ];

    const handleDownload = async (fileName, routeName) => {
        setLoading(true)
        apiService.getReport(scenario.id, routeName).then(async(response) => {
            if (response) {
                const blob = await response.blob();
                saveAs(blob, model.name + " - " +scenario.name + ' - ' + fileName);
            }
        })
        setLoading(false)
    }

    const handleClose = () => {
        setOpen(false);
    }

    return (
        <TailwindModal
            isOpen={open}
            onClose={handleClose}
            title={`${model.name} / ${(sensitivity === 'null') ? scenario.name : sensitivity.name} / Reports`}
            size="lg"
            showCloseButton={true}
        >
            <div className="flex flex-col gap-4">
                <p className="text-slate-700">
                    In this section, you will find the reports available for your financial model.
                </p>

                <div className="flex flex-col gap-2">
                    {files.map((file, index) => (
                        <div
                            key={index}
                            className="flex items-center justify-between p-4 border border-slate-900 rounded-lg"
                        >
                            <span className="text-slate-900 font-medium">
                                {index + 1}. {file.name}
                            </span>

                            <TailwindButton
                                variant="secondary"
                                size="sm"
                                onClick={() => handleDownload(file.name, file.routeName)}
                                disabled={loading}
                                icon={loading ? undefined : "download"}
                            >
                                {loading ? (
                                    <div className="flex items-center gap-2">
                                        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-slate-900"></div>
                                        Downloading...
                                    </div>
                                ) : (
                                    'Download'
                                )}
                            </TailwindButton>
                        </div>
                    ))}
                </div>
            </div>
        </TailwindModal>
    )
}
